import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const dashboardTextButton: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'dsgnsys_DashboardTextButton_dataBinding_panelTitle',
    helpId: 'a064445c-6c48-4b3c-b3dc-6f6e19a848c9',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'DashboardTextButtonRole',
      bindings: [
        {
          title: 'dsgnsys_DashboardTextButton_dataBinding_label_label',
          prop: 'label',
          supportedFieldTypes: [FieldType.text, FieldType.richText],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'dsgnsys_DashboardTextButton_dataBinding_link_label',
          prop: 'link',
          supportedFieldTypes: [FieldType.url],
          defaultFieldType: FieldType.url,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
